import { fromJS, Map } from "immutable";
import { CLOSE_SNACKBAR, OPEN_SNACKBAR } from "../actions/snackbar.actions";

// dedicated reducer for snackbar

export const initialState = fromJS({
  isOpen: false,
  message: "",
  duration: 6000,
  variant: "success",
});

export const SNACKBAR_REDUCER = "snackbar";

export default function snackbarReducer(state: Map = initialState, action) {
  switch (action.type) {
    case OPEN_SNACKBAR:
      return state
        .set("isOpen", true)
        .set("message", action.message)
        .set("variant", action.variant)
        .set("duration", action.duration || 6000);
    case CLOSE_SNACKBAR:
      return state.set("isOpen", false).set("message", "");
    default:
      return state;
  }
}
